import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  { path: '', redirectTo: 'facturacion', pathMatch: 'full' },
  { path: 'facturacion', component: AppComponent },
  { path: 'facturacion/:id', component: AppComponent },
  { path: 'home/facturacion', component: AppComponent },
  { path: 'home/facturacion/:id', component: AppComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
